<p-dialog
  [header]="alarmType()"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [breakpoints]="{ '960px': '95vw' }"
  [style]="{ width: '70vw' }"
  [draggable]="false"
  appendTo="body"
>
  <p-table
    [value]="historicAlarms()"
    [scrollable]="true"
    scrollHeight="50vh"
    [breakpoint]="'960px'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Num contador</th>
        <th>Tipo alarma</th>
        <th>Fecha Inicio</th>
        <th>Fecha desactivación</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-alarm>
      <tr [class.opacity-50]="alarm.expiredAt">
        <td>{{ alarm.meterSerialNumber }}</td>
        <td>{{ alarm.type.description }}</td>
        <td>{{ alarm.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          @if (alarm.expiredAt) {
            {{ alarm.expiredAt | date: 'dd/MM/yyyy HH:mm' }}
          }
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center p-4">No se encontraron alarmas registradas.</td>
      </tr>
    </ng-template>
  </p-table>

  @if (historicTotalElements() > 0) {
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="currentPage() * historicPageSize"
      [rows]="historicPageSize"
      [totalRecords]="historicTotalElements()"
    />
  }

  <ng-template pTemplate="footer">
    <div class="d-flex w-100 justify-content-end gap-2">
      @if (firstAlarmActive()) {
        <p-button label="Desactivar" severity="danger" (onClick)="deactivate()" />
      }
      <p-button
        label="Cerrar"
        severity="secondary"
        [text]="true"
        (onClick)="onVisibleChange(false)"
      />
    </div>
  </ng-template>
</p-dialog>
